import React from 'react';
import PropTypes from 'prop-types';

import SvgIcon from '@mui/material/SvgIcon';
import makeStyles from '@mui/styles/makeStyles';

import classNames from 'classnames';


import LoadingButton from '../Shared/LoadingButton'




const useStyles = makeStyles((theme) => ({
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    },
}));






export default function PdfLoadingButton({ disabled, onClick, label, pending, style, ...rest }) {

    const classes = useStyles();

    let PdfIcon = (
        <SvgIcon className={classNames(classes.leftIcon, classes.iconSmall)} style={{ width: '20px', height: '20px' }} viewBox="0 0 22 22" >
            <path d="M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z" />
        </SvgIcon>
    );

    return (
        <LoadingButton
            disabled={disabled}
            onClick={onClick}
            label={label}
            pending={pending}
            icon={PdfIcon}
            color="primary"
            style={style}
            {...rest}
        />
    );
}


PdfLoadingButton.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    pending: PropTypes.bool.isRequired
};
